import React, { memo, useState, useEffect } from 'react';
import { string, shape, oneOfType } from 'prop-types';

import _fallbackImage from 'assets/img/fallbackImage_60x60.jpeg';
import { usePrevious } from 'hooks';

const Image = ({ testId, className, src, fallbackImage, alt }) => {
  const [imageError, setImageError] = useState(false);
  const [_src, _setSrc] = useState(fallbackImage);
  const prevSrc = usePrevious(src);

  useEffect(() => {
    if (prevSrc !== src) {
      _setSrc(src);
    }
    if (!src) {
      _setSrc(fallbackImage);
    }
  }, [fallbackImage, prevSrc, src]);

  const onError = () => {
    if (!imageError) {
      _setSrc(fallbackImage);
      return setImageError(true);
    }
  };

  const onLoad = () => {
    if (src) {
      _setSrc(src);
    }
  };

  return (
    <img
      onLoad={onLoad}
      onError={onError}
      src={_src}
      alt={alt}
      data-testid={testId}
      className={`${className} transition-all`}
    />
  );
};

Image.propTypes = {
  className: string,
  testId: string,
  src: oneOfType([string, shape({})]),
  fallbackImage: oneOfType([string, shape({})]),
  alt: string.isRequired,
};
Image.defaultProps = {
  className: 'w-full h-full mr-auto rounded-md object-cover object-center',
  testId: 'image',
  fallbackImage: _fallbackImage,
};

export default memo(Image);
